import { render } from "./MemberCard.vue?vue&type=template&id=05166232&ts=true"
import script from "./MemberCard.vue?vue&type=script&lang=ts"
export * from "./MemberCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__